/**
 * ADD FRIENDS — built to the owner's own mockup (24.9.2026, materials/Add-Friends-vedos.png, measured at 941 × 1672:
 * "Tässä teille vedos miltä popupin pitäisi näyttää, graafinen otsikko esim pitää tehdä!!! Pitää olla myyvä!").
 *
 * The background is the owner's own picture (24.9.2026, "Kokeillaan myös parempaa taustaa: uusi-tausta-hq"): the neon
 * frame, the four corner palms and the ADD FRIENDS title with its crown, all in one 9-slice so the popup still grows
 * with the crew. A row carries the portrait in the kit's thin ring, the name and the kit's short pill with the word,
 * and the whole row is the control (OD-039) — with NO plate behind it ("NUO PILLERIT TAUSTALTA HELVETTIIN JA
 * ÄKKIÄ!!!!"). No cyan anywhere, and NO GLOW behind a portrait ("SANOIN ETTÄ TUO VITUN GLOW AVATARIEN TAUSTALTA
 * HELVETTIIN JA HETI!!!!"): the drawn ring piece carried a glow, so it is gone and the portrait takes the game's own
 * ring — a plain edge in the player's symbol colour, the board's rule: man blue, woman pink, anything else gold. The
 * word's pill is electric blue.
 *
 * The crew of the room you are in, so the row is the name and the one thing you can do to it — the panel only ever
 * opens from a game (owner: "Tuo Add friends on vain pelien yhteydessä joten tuo 'Played with you' on turha ja
 * typerä!"). ADD sends a request (a request the other way is accepted on the spot), SENT waits, FRIENDS is already
 * done. Reporting a player is on the lobby seat, not here.
 */
import { art } from '../art';
import { useState } from 'preact/hooks';
import { social } from '../net/api';
import { principal, pub, sheet, showToast } from '../state/store';
import { useOverview } from './Friends';
import { Avatar } from './bits';
import { PopupPanel } from './PopupPanel';
import { sfx } from '../audio/sfx';

/** the popup's box on the stage: the owner's own background drawn 779.4 wide puts its neon at x 130 … 805, top 329 —
    where his mockup (materials/Add-Friends-vedos.png) has it */
const PLACE = { x: 77.6, y: 200.5, w: 779.4 };
const clip = (s: string, n: number) => (s.length > n ? `${s.slice(0, n - 1)}…` : s);

export function AddFriendsSheet() {
  const [o, reload] = useOverview(); const [busy, setBusy] = useState('');
  const s = pub.value; const meId = principal.value?.id; const close = () => { sheet.value = null; };
  const others = (s?.players ?? []).filter((p) => p.id !== meId);
  const status = (id: string): 'friend' | 'requested' | 'incoming' | 'none' => !o ? 'none' : o.friends.some((f) => f.id === id) ? 'friend' : o.outgoing.some((q) => q.to.id === id) ? 'requested' : o.incoming.some((q) => q.from.id === id) ? 'incoming' : 'none';
  const add = async (id: string) => { if (!s || busy) return; setBusy(id); sfx.tap(); try { const r = await social.request(id, s.roomId); showToast(r.accepted ? 'You are now friends' : 'Request sent'); await reload(); } catch (e) { const c = (e as { code?: string }).code; showToast(c === 'BLOCKED' ? 'Not available' : 'Could not send the request'); } finally { setBusy(''); } };
  const accept = async (id: string) => { const q = o?.incoming.find((x) => x.from.id === id); if (!q) return; setBusy(id); sfx.tap(); try { await social.accept(q.id); showToast('You are now friends'); await reload(); } catch { showToast('Could not accept'); } finally { setBusy(''); } };
  const allFriends = others.length > 0 && others.every((p) => status(p.id) === 'friend');
  const plates = { '--pill': `url(${art('/art/lobby-kit/pill.short.png')})` } as Record<string, string>;

  return (
    <div class="sheet-backdrop" onClick={close} data-testid="addfriends-sheet">
      <PopupPanel title="ADD FRIENDS" label="Add friends" onClose={close} closeTestid="addfriends-close"
        plate="addfriends" place={PLACE} palms={false} rule={false} head={false} cls="af-panel">
        <p class="af-lead">Your crew from this match</p>
        <ul class="af-list" data-testid="addfriends-list" style={plates}>
          {others.length === 0 && <li class="af-empty" data-testid="addfriends-empty">Nobody else is in this room.</li>}
          {others.map((p) => {
            const st = status(p.id); const label = st === 'friend' ? 'FRIENDS' : st === 'incoming' ? 'ACCEPT' : st === 'requested' ? 'SENT' : 'ADD';
            const tap = st === 'incoming' ? () => void accept(p.id) : () => void add(p.id);
            return (
              <li key={p.id}>
                {/* one control: the whole row is the button (OD-039) */}
                <button class="af-row" type="button" data-testid={st === 'incoming' ? `af-accept-${p.id}` : `af-add-${p.id}`}
                  aria-label={`${label} ${p.displayName}`} disabled={st === 'friend' || !!busy || st === 'requested' || !o} onClick={tap}>
                  <span class={`af-face i-${p.identity === 'man' ? 'man' : p.identity === 'woman' ? 'woman' : 'other'}`}>
                    <Avatar avatarId={p.avatarId} name={p.displayName} state="happy" bare cls="disc" />
                  </span>
                  <span class="af-name">{clip(p.displayName, 12)}</span>
                  <span class="af-pill">{label}</span>
                </button>
              </li>);
          })}
        </ul>
        <img class="af-rule" src={art('/art/lobby-kit/row.divider.png')} alt="" draggable={false} />
        <p class="af-note">{allFriends ? 'You are friends with the whole crew.' : 'Requests are accepted in Friends.'}</p>
      </PopupPanel>
    </div>
  );
}
